import { NgModule } from "@angular/core";
import { PaginationModule, SpinnerModule } from "@spartacus/storefront";
import { UdxOrderQRComponent } from "./udx-order-qr.component";
import { CommonModule } from "@angular/common";
import { I18nModule, provideDefaultConfig } from "@spartacus/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { DayjsFormatModule } from "../../../utilities/date/dayjs-format.module";
import { RouterModule } from "@angular/router";

@NgModule({
    imports: [
        PaginationModule,
        SpinnerModule,
        CommonModule,
        I18nModule,
        FormsModule,
        NgSelectModule,
        DayjsFormatModule,
        RouterModule,
        UdxOrderQRComponent
    ],
    exports: [
        UdxOrderQRComponent
    ],
    providers: [
        provideDefaultConfig({
            cmsComponents: {
                OrderTicketQRComponent: {
                    component: UdxOrderQRComponent
                }
            }
        }),
    ]
})
  export class UDXOrderQRModule {}
  